import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'


const FeatureWork = (props) => {
    const {work:{name,image,description,technology,repo,preview}} = props;
    return (
        <Row className="align-items-center featured-project my-4">
            <Col md={7}>
                <div className="project-img">
                    <img className="img-fluid" src={image} alt=""/>
                </div>
            </Col>
            <Col md={5}>
                <div className="project-info px-4 py-2 rounded"
                     style={{backgroundColor:"#172A45"}}
                >
                    <p className="text-green small m-0">0{props.no} </p>
                    <h3>{name}</h3>
                    <p>
                        {description} 
                    </p>
                    <div className="technology">
                        {
                            technology.map(tech => <span>{tech}</span>)
                        }
                    </div>
                    <ul className="preview list-inline mt-4">
                        
                        {
                            repo === '#' ||
                            <li className="list-inline-item">
                                <a target="_blank" rel="noreferrer" href={repo}><FontAwesomeIcon icon={faGithub}/></a>
                            </li>
                        }
                        {
                            preview === '#' ||
                            <li className="list-inline-item">
                                <a target="_blank" rel="noreferrer" href={preview}><FontAwesomeIcon icon={faExternalLinkAlt}/></a>
                            </li>
                        }
                       
                    </ul>
                </div>
            </Col>
        </Row>
    );
};

export default FeatureWork;